'use client'
import { Search, ArrowRight } from 'lucide-react'
import { FormEvent } from 'react'
import { useRouter } from 'next/navigation'
import './styles.scss'

interface SearchFieldProps {
  placeholder?: string
  action?: string
  initialValue?: string
  className?: string
}

export const SearchField = ({
  placeholder = 'O que a sua indústria precisa hoje?',
  action = '/products/1',
  initialValue = '',
  className = '',
}: SearchFieldProps) => {
  const router = useRouter()

  const handleSearch = (e: FormEvent<HTMLFormElement>) => {
    const formData = new FormData(e.currentTarget)
    const rawQuery = formData.get('q')
    const searchQuery =
      typeof rawQuery === 'string' ? rawQuery.trim() : initialValue.trim()

    if (!searchQuery) {
      e.preventDefault()
      return
    }

    e.preventDefault()
    router.push(`${action}?q=${encodeURIComponent(searchQuery)}`)
  }

  return (
    <form
      className={`search-field ${className}`}
      action={action}
      method="get"
      onSubmit={handleSearch}
    >
      <div className="search-field-input">
        <div className="search-field-icon-wrapper">
          <Search size={24} />
        </div>
        <input
          name="q"
          type="text"
          aria-label={placeholder}
          placeholder={placeholder}
          defaultValue={initialValue}
        />
      </div>
      <button type="submit" className="search-field-button" aria-label="Buscar">
        <ArrowRight size={24} />
      </button>
    </form>
  )
}
